// removed by extract-text-webpack-plugin
module.exports = {"expand-item":"PlaneDetails__expand-item__2yq24"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OurAircraft/List/PlaneDetails/PlaneDetails.scss
// module id = 440
// module chunks = 0